import React from 'react';
import cn from 'classnames';
export default function PaymentIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    style = _ref.style,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("span", {
    role: "img",
    className: cn('icons', className),
    style: style
  }, /*#__PURE__*/React.createElement("svg", {
    width: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#E1E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 11.1428H4V8.57141H20V11.1428Z",
    fill: "#092235"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "0.4",
    d: "M18.2222 6C19.2028 6 20 6.76741 20 7.71429V8.57143H4V7.71429C4 6.76741 4.79583 6 5.77778 6H18.2222ZM20 16.2857C20 17.2312 19.2028 18 18.2222 18H5.77778C4.79583 18 4 17.2312 4 16.2857V11.1429H20V16.2857ZM7.11111 14.5714C6.86667 14.5714 6.66667 14.7643 6.66667 15C6.66667 15.2357 6.86667 15.4286 7.11111 15.4286H8.88889C9.13333 15.4286 9.33333 15.2357 9.33333 15C9.33333 14.7643 9.13333 14.5714 8.88889 14.5714H7.11111ZM10.6667 15.4286H14.2222C14.4667 15.4286 14.6667 15.2357 14.6667 15C14.6667 14.7643 14.4667 14.5714 14.2222 14.5714H10.6667C10.4222 14.5714 10.2222 14.7643 10.2222 15C10.2222 15.2357 10.4222 15.4286 10.6667 15.4286Z",
    fill: "#092235"
  })));
}